export function getSanitizedString(input: string): string {
  // Use a regular expression to remove HTML tags
  return new DOMParser().parseFromString(input, 'text/html').body.textContent ?? '';
}
